import { useHistory, useRouteMatch } from "react-router";

export default function useHistoryPush(to: string) {
    const match = useRouteMatch({
        path: to,
        exact: true
    });
    const history = useHistory();
    return () => {
        if (!match) {
            history.push(to);
        }
    };
}
